import {
  type EthApproveTransaction,
  type EthPlaceOrderTransaction,
  type EthSendTransaction,
  type EthSignTransaction,
  type EthSignTypedData,
  type EthTransferTransaction,
  type PersonalSign,
} from "@umami/chains";

// Type for eth_signTransaction parameters
export type EthSignTransactionParams = {
  from: string;
  to?: string;
  data?: string;
  gas?: string;
  gasPrice?: string;
  value?: string;
  nonce?: string;
};

// Type guards for different operation types
export const isPersonalSign = (operation: unknown): operation is PersonalSign =>
  typeof operation === "object" &&
  operation !== null &&
  "type" in operation &&
  operation.type === "personal_sign";

export const isEthSignTransaction = (operation: unknown): operation is EthSignTransaction =>
  typeof operation === "object" &&
  operation !== null &&
  "type" in operation &&
  operation.type === "eth_signTransaction";

export const isEthSignTypedData = (operation: unknown): operation is EthSignTypedData =>
  typeof operation === "object" &&
  operation !== null &&
  "type" in operation &&
  operation.type === "eth_signTypedData";

export const isEthTransactionOperation = (
  operation: unknown
): operation is
  | EthSendTransaction
  | EthApproveTransaction
  | EthTransferTransaction
  | EthPlaceOrderTransaction =>
  typeof operation === "object" &&
  operation !== null &&
  "type" in operation &&
  (operation.type === "eth_approve" ||
    operation.type === "eth_transfer" ||
    operation.type === "eth_placeOrder" ||
    operation.type === "eth_sendTransaction");

export const isEthSignTransactionParams = (obj: unknown): obj is EthSignTransactionParams =>
  typeof obj === "object" &&
  obj !== null &&
  "from" in obj &&
  typeof (obj as { from: unknown }).from === "string";

export const isEthSendRawTransaction = (
  operation: unknown
): operation is { type: string; rawTransaction: string } =>
  typeof operation === "object" &&
  operation !== null &&
  "type" in operation &&
  "rawTransaction" in operation &&
  typeof (operation as { rawTransaction: unknown }).rawTransaction === "string";
